require('initializers/gettext').default(__TRANSLATIONS__.gettext.he); // eslint-disable-line no-undef
require('initializers/i18n').default('he', __TRANSLATIONS__.i18n.he); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/he');
require('jquery-ui/ui/i18n/datepicker-he');
require('moment/locale/he');
